<template>
	<el-tabs>
		<el-tab-pane >
			<span slot="label"><i class="el-icon-document-remove"></i>{{value.ming}}组件</span>
			<div style="padding: 20px;">
				
				<div v-for="(l,i) in value.shu" :key="i" style="display: flex;position: relative;align-items: center;" class="zidingyi_sc">
					<div class="zidingyi_shanchu" @click.stop="Shanchu(i)"><i class="el-icon-circle-close"></i></div>
					 <el-checkbox v-model="l.checked" style="padding-right: 20px;"></el-checkbox>
					 <el-input v-model="l.shuliang" placeholder="请输入内容" style="width: 40%;"></el-input>
					<el-input v-model="l.ming" placeholder="请输入内容" style="width: 40%;"></el-input>
				</div>
				
			
					
				<el-button type="primary"  size="mini"  @click="Jia" style="margin-top: 20px;" >+新增</el-button>	
			</div>
		</el-tab-pane>
		<el-tab-pane>
			<span slot="label"><i class="el-icon-menu"></i> 组件样式</span>
			<div class="big_box" v-if="value.yangshi">
				<div style="padding: 20px 10px; color: #606266;">数量</div>
				<el-input v-model="value.yangshi.font_size" placeholder="px"> <template slot="prepend">字体大小</template></el-input>
				<el-input v-model="value.yangshi.color" placeholder="请输入颜色" > <template slot="prepend">颜色</template></el-input>
				<el-input v-model="value.yangshi.font_weight" placeholder="请输入颜色" > <template slot="prepend">加粗</template></el-input>
			</div>
			<div class="big_box" v-if="value.yangshis">
				<div style="padding: 20px 10px;color: #606266;">类名</div>
				<el-input v-model="value.yangshis.font_size" placeholder="px"> <template slot="prepend">字体大小</template></el-input>
				<el-input v-model="value.yangshis.color" placeholder="请输入颜色" > <template slot="prepend">颜色</template></el-input>
				<el-input v-model="value.yangshis.font_weight" placeholder="请输入颜色" > <template slot="prepend">加粗</template></el-input>
			</div>
		</el-tab-pane>
	</el-tabs>
</template> 

<script>
	export default {
		name: 'zijin_bianji',
		data(){
			return{
				checked:true
			}
		},
		props: {
			value: {
				type: [Object, Array],
				default () {
					return {}
				}
			}
		},
		methods: {
			Jia() {
				this.value.shu.push({
					tu: 'http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_11/pMVvuzinpnD1pNIfPnLOMHh0NVCLnl.jpg',
					ming: '名称'
				})
			},
			Shanchu(e) {
				this.value.shu.splice(e, 1);
			}
		}

	}
</script>
<link rel="stylesheet" href="Yangshi.css">
